import React from "react";

type SmallCarretProps = {
  color?: string;
  direction?: "up" | "down" | "left" | "right";
};

const SmallCarret: React.FC<SmallCarretProps> = ({
  color = "#000000",
  direction = "up",
}) => {
  const getRotation = (dir: SmallCarretProps["direction"]) => {
    switch (dir) {
      case "up":
        return 0;
      case "right":
        return 90;
      case "down":
        return 180;
      case "left":
        return -90;
      default:
        return 0;
    }
  };

  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform={`rotate(${getRotation(direction)} 12.5 12)`}>
        <path
          d="M7.91 15.41L12.5 10.83L17.09 15.41L18.5 14L12.5 8L6.5 14L7.91 15.41Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default SmallCarret;
